import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import {
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import TrioPush, { TrioPushProps } from 'src/components/TrioPush'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'

import { PictureColumnContentBlockProps } from './props'

const PictureColumnContent: FC<BlockProps<PictureColumnContentBlockProps>> = ({
  configuration,
  locale,
  data,
}) => {
  const props: TrioPushProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          ...(data.sectionTitle && {
            tag: data.sectionTitle || '',
          }),
          ...(data.description && {
            richTextProps: RichTextTransformer(
              data.description,
              configuration,
              locale
            ),
          }),
        },
      }),
      pictureProps: {
        imageProps: ImageTransformer(unwrapMedia(data.desktopImage)),
        mobileImageProps: ImageTransformer(unwrapMedia(data.mobileImage)),
      },
      pushes: data.columnedContent?.length
        ? data.columnedContent.map((item) => ({
            ...(item.ctaUrl && {
              actionButtonProps: {
                ...ButtonTransformer({
                  data: {
                    label: item.ctaTitle,
                    target: item.ctaTarget,
                    url: item.ctaUrl,
                  },
                  theme: data.theme?.data,
                }),
              },
            }),
            title: item.title || '',
            richTextProps: { html: item.text || '' },
          }))
        : [],
      color: getThemeColor(data?.theme?.data),
    }),
    [data, configuration, locale]
  )

  return <TrioPush {...props} />
}

export default PictureColumnContent
